import { ApplicationEntity } from "@/model/entity/application-entity"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"
const { VUE_APP_COMPANY_STATUSES } = process.env

export class Company extends ApplicationEntity {
  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.company.name", isFilterable: true })
  name: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.company.dsw_code",
    isFilterable: true
  })
  dswCode: string

  productVariants: string

  allProductsEnabled: boolean

  defaultProduct: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.company.comment" })
  comment: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.company.status" })
  status: string

  delisUser: string

  delisPass: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.company.parcel_export_disabled" })
  parcelExportDisabled: boolean

  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.company.collection_request_disabled" })
  collectionRequestDisabled: boolean

  constructor(
    name: string = "",
    dswCode: string = "",
    productVariants: string = "101",
    allProductsEnabled: boolean = false,
    defaultProduct: string = "101",
    comment: string = "",
    status: string = "ENABLED",
    delisUser: string = "",
    delisPass: string = "",
    parcelExportDisabled: boolean = false,
    collectionRequestDisabled: boolean = false,
    id?: number
  ) {
    super(id)
    this.name = name
    this.productVariants = productVariants
    this.allProductsEnabled = allProductsEnabled
    this.defaultProduct = defaultProduct
    this.dswCode = dswCode
    this.comment = comment
    this.status = status
    this.delisUser = delisUser
    this.delisPass = delisPass
    this.parcelExportDisabled = parcelExportDisabled
    this.collectionRequestDisabled = collectionRequestDisabled
  }
}
